document.querySelector('.vehicle-cta-modal__buttons')?.addEventListener('click', (e) => {
    if (e.target.closest('.btn')) {
        $('.modal--vehicle-cta').modal('hide');
    }
});
